import LocalizedStrings from 'react-localization'
import it from '@localization/it'
import en from '@localization/en'

const Localization = new LocalizedStrings({
    it, en
})

export default Localization